/* Apply Shopify's vendor filter only when the complete query names a brand. */
(() => {
  'use strict';
  const config = document.currentScript;
  if (!config?.dataset.searchUrl || !config.dataset.vendors) return;
  const searchPage = new URL(config.dataset.searchUrl, window.location.origin);
  const normalize = value => value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
  const vendors = new Map(JSON.parse(config.dataset.vendors).map(vendor => [normalize(vendor), vendor]));

  function matchingVendor(query) {
    // Quotes are allowed around a complete brand. Never rewrite the customer's q.
    const term = query.trim().replace(/^"([^"\\]+)"$/, '$1');
    return vendors.get(normalize(term));
  }
  function isSearchPage(url) {
    return url.origin === searchPage.origin && url.pathname === searchPage.pathname;
  }
  function setBrandField(form, name, value) {
    let field = form.querySelector(`input[data-yoko-brand-field][name="${name}"]`);
    // Keep explicit fields owned by the theme or a customer-selected filter.
    if (!value || form.querySelector(`[name="${name}"]:not([data-yoko-brand-field])`)) {
      field?.remove();
      return;
    }
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      field.dataset.yokoBrandField = '';
      form.appendChild(field);
    }
    field.value = value;
  }

  // Delegation includes the mobile drawer and forms refreshed in the theme editor.
  document.addEventListener('submit', event => {
    const form = event.target;
    const input = form.querySelector?.('input[type="search"][name="q"]');
    if (!input || form.method.toLowerCase() !== 'get' || !isSearchPage(new URL(form.action, window.location.href))) return;
    const vendor = matchingVendor(input.value);
    setBrandField(form, 'filter.p.vendor', vendor);
    setBrandField(form, 'type', vendor ? 'product' : null);
  }, true);

  function prepareSearchLink(event) {
    const link = event.target.closest?.('a[href]');
    if (!link || link.matches('.active-fl, .load-more') || link.closest('.pagination-wrapper')) return;
    const url = new URL(link.href, window.location.href);
    if (!isSearchPage(url) || !url.searchParams.has('q')) return;
    // Preserve pagination, explicit filters, and remove-filter navigation.
    if (url.searchParams.has('page') || [...url.searchParams.keys()].some(key => key.startsWith('filter.'))) return;
    const vendor = matchingVendor(url.searchParams.get('q'));
    if (!vendor) return;
    url.searchParams.set('filter.p.vendor', vendor);
    url.searchParams.set('type', 'product');
    link.href = url.pathname + url.search + url.hash;
  }
  // Native links work for touch, keyboard, middle-click and opening a new tab.
  ['pointerdown', 'focusin', 'click', 'auxclick', 'contextmenu'].forEach(name => {
    document.addEventListener(name, prepareSearchLink, true);
  });
})();
